import { FLOATING_ELEMENT_PLACEMENT } from '../../../../constants/common'
import Button, { BUTTON_HEIGHT_32 } from '../../../Button'

import * as styles from './ProfileContactsWidgetListCellButton.module.css'

import DeleteIcon from '../../../../icons/delete.svg'

function ProfileContactsWidgetListCellButton({
  Icon = DeleteIcon,
  className = styles.ProfileContactsWidgetListCellButton,
  height = BUTTON_HEIGHT_32,
  ...restProps
}) {
  return (
    <Button.Outlined
      {...restProps}
      isGrey
      beforeIconProps={{ Icon }}
      className={className}
      height={height}
      tooltipPlacement={FLOATING_ELEMENT_PLACEMENT.top}
    />
  )
}

export default ProfileContactsWidgetListCellButton
